import { render } from "./EmptyStory.vue?vue&type=template&id=4776cf71&scoped=true"
import script from "./EmptyStory.vue?vue&type=script&lang=js"
export * from "./EmptyStory.vue?vue&type=script&lang=js"

import "./EmptyStory.vue?vue&type=style&index=0&id=4776cf71&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4776cf71"]])

export default __exports__